import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCouponFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.5 4.25H4.75C3.231 4.25 2 5.443 2 6.914v10.172c0 1.471 1.231 2.664 2.75 2.664H15.5V18.3a.75.75 0 0 1 1.5 0v1.45h2.25c1.519 0 2.75-1.193 2.75-2.664V6.914c0-1.471-1.231-2.664-2.75-2.664H17v1.7a.75.75 0 0 1-1.5 0zM17 8.8a.75.75 0 0 0-1.5 0v1.9a.75.75 0 0 0 1.5 0zm0 4.75a.75.75 0 0 0-1.5 0v1.9a.75.75 0 0 0 1.5 0z",
    clipRule: "evenodd"
  }));
}
var IcCouponFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCouponFill));

export { IcCouponFill as I };
